import { createFileRoute } from '@tanstack/react-router'

// No requireGuest: the link is clicked from the new inbox, sometimes on a
// device that is already signed in. The token is the proof either way.
export const Route = createFileRoute('/confirm-email-change')({
  validateSearch: (raw: Record<string, unknown>) => ({
    token: typeof raw.token === 'string' ? raw.token : '',
  }),
})
